import {getCheckoutClient} from '../config/CheckoutClient';
import {validatePresaleCoupon, getHiddenPriceLevels, setShowSuccess, setCouponCode, setPresaleCode, setIsPresaleValid, setIsPresaleApplied} from 'checkout/views/coupon/actions/coupon';
import { setEventTimes, setSelectedEvent, setEventsToday, setFetchedEventsToday, setSelectedEventTimeObject } from '../views/series/actions/event-series';
import { clearSelectedPriceLevels } from '../views/ticket-picker/actions/ticket-picker';
import { clearSelectedBundles } from '../views/bundle-picker/actions/bundle-picker';
import { clearSelectedProducts } from '../views/product-picker/actions/product-picker';
import { removeListingItem } from '../../listing/helpers/storage';
import { reservationActive } from '../selectors/reservation';
import { isValidDateObject, ISOStringToDate } from '../../helpers/time';
import { serializeToUrl } from 'checkout/helpers/helpers';

export function setEventData(data) {
    return {type: "FETCH_EVENT", data}
}

export function refreshEventData(data) {
    return {type: "REFRESH_EVENT", data}
}

export function setPriceLevels(data) {
    return {type: "SET_PRICE_LEVELS", data}
}

export function updatePriceLevels(data) {
    return {type: "UPDATE_PRICE_LEVELS", data}
}
export function setBundles(data) {
    return {type: "SET_BUNDLES", data}
}

export function setProducts(data) {
    return {type: "SET_PRODUCTS", data}
}

export function setChildEvent(data) {
    return {type: "SET_CHILD_EVENT", data}
}

export function setEventRefreshLoading(value) {
    return {type: "SET_EVENT_REFRESH_LOADING", value}
}

export function fetchEvent() {
    return (dispatch, getState) => {
        let state = getState();
        let now = new Date();
        let timestamp = Math.floor(now.getTime() / 1000);
        dispatch(setEventRefreshLoading(true));
        return fetch(state.ui.apiUrl + '/listing-settings/' + state.ui.listingId + '/listing-data?timestamp=' + timestamp).then((res) => {
            return res.json();
        }).then(result => {
            if (result && result.attributes && result.attributes.listing_data) {
                //refresh state
                let state = getState();
                //do not update if checkout is being actively used
                if (!reservationActive(state) && !state.ui.overlay) {
                    dispatch(refreshEventData(result.attributes.listing_data));
                    if (result.attributes.series && result.attributes.series.events_today) {
                        dispatch(setFetchedEventsToday(true));
                        if (Array.isArray(result.attributes.series.events_today)) {
                            let now = new Date();
                            dispatch(setEventsToday(result.attributes.series.events_today.map(event => {
                                //may be behind on marking as post_sale due to caching, so check against salesClose time here
                                let salesCloseTime = ISOStringToDate(event.salesClose);
                                if (isValidDateObject(salesCloseTime) && salesCloseTime.getTime() < now.getTime()) {
                                    return {
                                        ...event,
                                        eventStatus: "post_sale",
                                    };
                                }
                                return event;
                            })));
                        } else {
                            dispatch(setEventsToday([]));
                        }
                    }
                }
            }
        }).catch(err => {
            console.log(err);
        }).finally(() => {
            dispatch(setEventRefreshLoading(false));
        });
    }
}

export function getEventPriceLevels() {
    return (dispatch, getState) => {
        let state = getState();
        let payload = {
            listingId: state.ui.listingId,
            eventId: Object.values(state.event.events)[0].event.event_id,
        };

        return fetch(state.ui.apiUrl + '/price-levels-event?' + serializeToUrl(payload), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            return response.json();
        }).then((data) => {
            dispatch(setPriceLevels(data.price_levels));
        }).catch(function(err) {
        });
    }
}

export function clearChildEventDetails() {
    return (dispatch, getState) => {
        const state = getState();
        dispatch(setEventTimes([]));
        dispatch(setChildEvent({}));
        dispatch(setSelectedEvent({}));
        removeListingItem(state.ui.listingSlug, 'selectedEventId');
        dispatch(setShowSuccess(false));
        dispatch(setCouponCode(""));
        dispatch(clearSelectedPriceLevels());
        dispatch(clearSelectedBundles());
        dispatch(clearSelectedProducts());
        dispatch(setPresaleCode(""));
        dispatch(setIsPresaleValid(false));
        dispatch(setIsPresaleApplied(false));
        dispatch(setSelectedEventTimeObject(null));
    }
}
